export const getProgressPercentage = (value: number, max = 100): number => {
  if (max === 0) return 0
  return Math.min(Math.max((value / max) * 100, 0), 100)
}
